import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import InsuranceSuperSaverWrapper from "@components/layouts/insuranceSuperSaverWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <InsuranceSuperSaverWrapper page="homePage">
            <main className="max-w-7xl mx-auto block px-4vw lg:px-4">
                <PrivacyPolicy />
            </main>
        </InsuranceSuperSaverWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
